import { auditService } from "@/stores/services/auditService";
import { decryptId } from "@/utils/utilsMethods";
import { Table } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";

interface TotalTableProps {
  companyId: number;
}
export default function TotalTable({ companyId }: TotalTableProps) {
  const [searchParams] = useSearchParams();
  const auditParam = searchParams.get("audit");
  const auditId = auditParam
    ? parseInt(decryptId(auditParam))
    : undefined;
  const { data } = auditService.useTableReportTotalQuery(
    auditId && auditId > 0 ? { companyId, auditId } : skipToken,
  );
  const columns = [
    {
      title: "Total Items",
      dataIndex: "totalItems",
      key: "totalItems",
    },
    {
      title: "CUMPLE",
      dataIndex: "compliance1",
      key: "compliance1",
    },
    {
      title: "NO CUMPLE",
      dataIndex: "compliance2",
      key: "compliance2",
    },
    {
      title: "CUMPLE PARCIALMENTE",
      dataIndex: "compliance3",
      key: "compliance3",
    },
    {
      title: "NO APLICA",
      dataIndex: "compliance4",
      key: "compliance4",
    },
    {
      title: "General",
      dataIndex: "general",
      key: "general",
      render: (text: any) => `${text} %`,
    },
  ];

  const counts = data?.counts ?? [];
  const tableData = [
    {
      key: "1",
      totalItems: counts.reduce((acc, item) => acc + item.count, 0),
      compliance1: counts.find((c) => c.compliance_id === 1)?.count || 0,
      compliance2: counts.find((c) => c.compliance_id === 2)?.count || 0,
      compliance3: counts.find((c) => c.compliance_id === 3)?.count || 0,
      compliance4: counts.find((c) => c.compliance_id === 4)?.count || 0,
      general: data?.general,
    },
  ];
  return (
    <div className="w-full overflow-auto">
      <Table columns={columns} dataSource={tableData} pagination={false} />
    </div>
  );
}
